const DEFAULT_TITLE = 'UITGELICHTE PODCASTS';

export { DEFAULT_TITLE as default };
